import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

export default function AnimateButton({ children, scale = { hover: 1.05, tap: 0.954 } }) {
  return (
    <motion.div whileHover={{ scale: scale?.hover }} whileTap={{ scale: scale?.tap }}>
      {children}
    </motion.div>
  );
}
AnimateButton.propTypes = {
  children: PropTypes.node,
  scale: PropTypes.object
};
